var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PensionUnitSelectionForm',{attrs:{"data":_vm.data,"query":_vm.CREATE_PENSION_UNIT_SELECTION},on:{"mutation-done":_vm.addToCache}})}
var staticRenderFns = []

export { render, staticRenderFns }